import { ScrollText } from "lucide-react";
import type { ModuleSpec } from "../types";

export const logsSpec: ModuleSpec = {
  id: "logs",
  icon: ScrollText,
  i18n: {
    namespace: "modules",
    titleKey: "logs.title",
    descriptionKey: "logs.description",
  },
  nav: {
    path: "/logs",
    group: "account",
    order: 60,
  },
  meta: {
    status: "active",
    description: "View system logs and activity",
  },
};
